import * as actionTypes from "../ActionTypes";

const initialState = {
  getPayment: [],
  getPaymentId: [],
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PAYMENT_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_PAYMENT_SUCCESS:
      return {
        ...state,
        getPayment: action.payload,
      };
    case actionTypes.GET_PAYMENT_FAIL:
      return {
        ...state,
        error: "",
      };
    case actionTypes.GET_BYID_PAYMENT_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_BYID_PAYMENT_SUCCESS:
      return {
        ...state,
        getPaymentId: action.payload,
      };
    case actionTypes.GET_BYID_PAYMENT_FAIL:
      return {
        ...state,
        error: "",
      };
    default:
      return state;
  }
};

export default store;
